import { render, staticRenderFns } from "./AddArticleReference.vue?vue&type=template&id=1f565f9e&"
import script from "./AddArticleReference.vue?vue&type=script&lang=js&"
export * from "./AddArticleReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports